/* ==========================================================================
   OFFKA GIRLS — formulaires de candidature et espace CLUB.
   Les données sont envoyées à l'application OFFKA GIRLS via le proxy Shopify.
   Aucune clé ni donnée confidentielle ici : la sécurité est assurée côté serveur.
   ========================================================================== */
(function () {
  'use strict';

  var TYPE_LABELS = { photo: 'Photo', carousel: 'Carrousel', reel: 'Reel', tiktok: 'TikTok' };
  var STATUS_LABELS = { pending: 'En attente', accepted: 'Récompensée', rejected: 'Non récompensée' };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showAlert(el, message) {
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-visible', !!message);
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function cleanHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^https?:\/\/(www\.)?(instagram\.com|tiktok\.com)\/@?/i, '')
      .replace(/^@+/, '')
      .replace(/[/?#].*$/, '')
      .toLowerCase();
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response
        .json()
        .catch(function () { return {}; })
        .then(function (data) { return { status: response.status, ok: response.ok, data: data }; });
    });
  }

  /* ---------- Candidature ---------- */

  function initApplyForm(form) {
    if (form.dataset.ogReady) return;
    form.dataset.ogReady = '1';
    var errorBox = form.querySelector('[data-og-error]');
    var submit = form.querySelector('[data-og-submit]');
    var success = form.parentElement.querySelector('[data-og-success]');
    var sending = false;

    // Le lien « conditions OFFKA GIRLS » ouvre la fenêtre des conditions
    var section = form.closest('section') || document;
    Array.prototype.forEach.call(form.querySelectorAll('[data-og-open-terms]'), function (link) {
      link.addEventListener('click', function (event) {
        var dialog = section.querySelector(link.getAttribute('href'));
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        dialog.showModal();
      });
    });
    Array.prototype.forEach.call(section.querySelectorAll('.og-dialog'), function (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.hasAttribute('data-og-close-terms')) dialog.close();
      });
    });

    function markInvalid(field, invalid) {
      if (field) field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (sending) return; // empêche les doubles envois
      showAlert(errorBox, '');

      var firstInvalid = null;
      Array.prototype.forEach.call(form.querySelectorAll('[required]'), function (field) {
        var invalid = field.type === 'checkbox' ? !field.checked : !String(field.value).trim();
        if (field.type === 'email' && !invalid) invalid = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim());
        markInvalid(field, invalid);
        if (invalid && !firstInvalid) firstInvalid = field;
      });

      var socials = form.querySelectorAll('[data-og-social]');
      var hasSocial = Array.prototype.some.call(socials, function (f) { return cleanHandle(f.value) !== ''; });
      Array.prototype.forEach.call(socials, function (f) { markInvalid(f, !hasSocial); });

      if (firstInvalid || !hasSocial) {
        var message = firstInvalid && firstInvalid.type === 'email' && firstInvalid.value
          ? form.dataset.msgEmail
          : firstInvalid ? form.dataset.msgRequired : form.dataset.msgSocial;
        if (!firstInvalid && !hasSocial) message = form.dataset.msgSocial;
        showAlert(errorBox, message);
        (firstInvalid || socials[0]).focus();
        return;
      }

      var fd = new FormData(form);
      var payload = {
        first_name: String(fd.get('first_name') || '').trim(),
        last_name: String(fd.get('last_name') || '').trim(),
        email: String(fd.get('email') || '').trim().toLowerCase(),
        instagram: cleanHandle(fd.get('instagram')),
        tiktok: cleanHandle(fd.get('tiktok')),
        country: String(fd.get('country') || ''),
        // Une seule case : « J'ai 18 ans ou plus et j'accepte les conditions OFFKA GIRLS »
        age_confirmed: fd.get('terms_accepted') === '1',
        terms_accepted: fd.get('terms_accepted') === '1',
        newsletter: false,
        website: String(fd.get('website') || '') // champ piège anti-robots
      };

      sending = true;
      setBusy(submit, true);

      postJson(form.getAttribute('action'), payload)
        .then(function (result) {
          if (result.ok) {
            form.hidden = true;
            if (success) {
              success.classList.add('is-visible');
              success.focus();
            }
            return;
          }
          if (result.status === 409) {
            showAlert(errorBox, form.dataset.msgDuplicate);
          } else {
            showAlert(errorBox, (result.data && result.data.message) || form.dataset.msgGeneric);
          }
        })
        .catch(function () {
          showAlert(errorBox, form.dataset.msgGeneric);
        })
        .then(function () {
          sending = false;
          setBusy(submit, false);
        });
    });
  }

  /* ---------- CLUB ---------- */

  function detectPlatform(url) {
    var match = /^https?:\/\/(?:[a-z0-9-]+\.)*(instagram\.com|tiktok\.com)\//i.exec(url);
    return match ? match[1].toLowerCase() : null;
  }

  function formatDate(iso) {
    var d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('fr-FR');
  }

  function formatMoney(amount) {
    if (amount == null) return '–';
    return Number(amount).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function shortUrl(url) {
    return String(url).replace(/^https?:\/\/(www\.)?/, '').slice(0, 48) + (String(url).length > 56 ? '…' : '');
  }

  function initClub(root) {
    if (root.dataset.ogReady) return;
    root.dataset.ogReady = '1';
    var endpoint = (root.dataset.endpoint || '/apps/offka-girls').replace(/\/$/, '');
    var demo = root.dataset.demo === 'true';
    var table = root.querySelector('[data-og-history]');
    var empty = root.querySelector('[data-og-history-empty]');
    var statAccepted = root.querySelector('[data-og-stat-accepted]');
    var statText = root.querySelector('[data-og-stat-text]');

    Array.prototype.forEach.call(root.querySelectorAll('[data-og-copy]'), function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-og-copy');
        var label = btn.textContent;
        var done = function () {
          btn.textContent = 'Code copié ✓';
          setTimeout(function () { btn.textContent = label; }, 2000);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      });
    });

    function renderHistory(items) {
      if (!table) return;
      var body = table.querySelector('tbody');
      body.innerHTML = items.map(function (s) {
        var status = STATUS_LABELS[s.status] ? s.status : 'pending';
        return '<tr>' +
          '<td data-label="Date">' + escapeHtml(formatDate(s.created_at)) + '</td>' +
          '<td data-label="Type">' + escapeHtml(TYPE_LABELS[s.content_type] || s.content_type) + '</td>' +
          '<td data-label="Lien"><a href="' + escapeHtml(s.url) + '" target="_blank" rel="noopener">' + escapeHtml(shortUrl(s.url)) + '</a></td>' +
          '<td data-label="Statut"><span class="og-status og-status--' + status + '">' + STATUS_LABELS[status] + '</span></td>' +
          '<td data-label="Récompense">' + (status === 'accepted' ? escapeHtml(formatMoney(s.reward_amount)) : '–') + '</td>' +
          '</tr>';
      }).join('');

      var accepted = items.filter(function (s) { return s.status === 'accepted'; }).length;
      var pending = items.filter(function (s) { return s.status === 'pending'; }).length;
      if (statAccepted) statAccepted.textContent = accepted;
      if (statText) statText.textContent = 'récompensée' + (accepted > 1 ? 's' : '') + (pending ? ' · ' + pending + ' en attente' : '');

      if (empty) {
        empty.hidden = items.length > 0;
        empty.textContent = 'Tu n\'as pas encore déposé de publication. À toi de jouer !';
      }
    }

    function loadHistory() {
      if (demo || !table) return;
      fetch(endpoint + '/submissions', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) { renderHistory((data && data.submissions) || []); })
        .catch(function () {
          if (empty) {
            empty.hidden = false;
            empty.textContent = 'Ton historique n\'est pas disponible pour le moment.';
          }
        });
    }

    var form = root.querySelector('[data-og-submit-form]');
    if (form) {
      var errorBox = form.querySelector('[data-og-error]');
      var okBox = form.querySelector('[data-og-ok]');
      var submit = form.querySelector('[data-og-submit]');
      var sending = false;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (sending) return; // empêche les doubles dépôts
        showAlert(errorBox, '');
        showAlert(okBox, '');

        var fd = new FormData(form);
        var url = String(fd.get('url') || '').trim();
        var type = fd.get('content_type');
        var urlField = form.querySelector('[name="url"]');

        if (!detectPlatform(url)) {
          urlField.setAttribute('aria-invalid', 'true');
          showAlert(errorBox, form.dataset.msgUrl);
          urlField.focus();
          return;
        }
        if (/\/stories\//i.test(url)) {
          urlField.setAttribute('aria-invalid', 'true');
          showAlert(errorBox, form.dataset.msgStory);
          urlField.focus();
          return;
        }
        urlField.setAttribute('aria-invalid', 'false');
        if (!type) {
          showAlert(errorBox, form.dataset.msgType);
          return;
        }
        if (fd.get('tagged') !== '1' || fd.get('disclosed') !== '1') {
          showAlert(errorBox, form.dataset.msgConfirm);
          return;
        }

        if (demo) {
          showAlert(okBox, 'Aperçu éditeur : le dépôt n\'est pas envoyé.');
          return;
        }

        sending = true;
        setBusy(submit, true);

        postJson(endpoint + '/submissions', {
          url: url,
          content_type: type,
          tagged: true,
          disclosed: true
        })
          .then(function (result) {
            if (result.ok) {
              form.reset();
              showAlert(okBox, form.dataset.msgSuccess);
              loadHistory();
            } else {
              showAlert(errorBox, (result.data && result.data.message) || form.dataset.msgGeneric);
            }
          })
          .catch(function () { showAlert(errorBox, form.dataset.msgGeneric); })
          .then(function () {
            sending = false;
            setBusy(submit, false);
          });
      });
    }

    loadHistory();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-og-apply]'), initApplyForm);
    Array.prototype.forEach.call(document.querySelectorAll('[data-og-club]'), initClub);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
